<template>
<div>
     <v-menu offset-x close-on-content-click>
                        <template v-slot:activator="{ on, attrs }">
                            <button
                                v-on="on"
                                v-bind="attrs"
                                class="hashTag-Button"
                            >
                                Add HashTag
                            </button>
                        </template>
                        <div class="mt-0 hastag_div" style="z-index: 2">
                            <div>
                                <v-text-field
                                    outlined
                                    placeholder="search"
                                    class="ml-2 mr-2 mt-0 pt-2"
                                    style="height: 70px"
                                ></v-text-field>
                            </div>
                            <div style="height: 120px">
                                <v-list>
                                    <v-list-item
                                        v-for="(item, index) in items"
                                        :key="index"
                                    >
                                        <v-list-item-title>{{
                                            item.title
                                        }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </div>
                    </v-menu>
</div>
</template>

<script>
export default {
    name: "menu",
    data() {
        return {
            viewMenu: false,
            top: "0px",
            left: "0px",
            items: [
                { title: "Click Me" },
                { title: "Click Me" },
                { title: "Click Me" },
                { title: "Click Me 2" },
                { title: "Click Me" },
                { title: "Click Me" },
                { title: "Click Me" },
                { title: "Click Me 2" },
                { title: "Click Me" },
                { title: "Click Me" },
                { title: "Click Me" },
                { title: "Click Me 2" },
            ],
        };
    },
    methods: {
        setMenu: function (top, left) {
            largestHeight =
                window.innerHeight - this.$$.right.offsetHeight - 25;
            largestWidth = window.innerWidth - this.$$.right.offsetWidth - 25;

            if (top > largestHeight) top = largestHeight;

            if (left > largestWidth) left = largestWidth;

            this.top = top + "px";
            this.left = left + "px";
        },

        closeMenu: function () {
            this.viewMenu = false;
        },

        openMenu: function (e) {
            this.viewMenu = true;

            Vue.nextTick(
                function () {
                    this.$$.right.focus();

                    this.setMenu(e.y, e.x);
                }.bind(this)
            );
            e.preventDefault();
        },
    },
};
</script>

<style scoped>
body {
    width: 100%;
    height: 100%;
}

h1 {
    font-size: 3em;
}

.center {
    text-align: center;
}

#demo {
    width: 100%;
    height: 100%;
}

#right-click-menu {
    background: #fafafa;
    border: 1px solid #bdbdbd;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
        0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    width: 250px;
    z-index: 999999;
}

#right-click-menu li {
    border-bottom: 1px solid #e0e0e0;
    margin: 0;
    padding: 5px 35px;
}

#right-click-menu li:last-child {
    border-bottom: none;
}

#right-click-menu li:hover {
    background: #1e88e5;
    color: #fafafa;
}
</style>